import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FeatherModule } from 'angular-feather';

import { CryptoJsService } from 'src/app/core/services/crypto-js.service';
@Component({
  selector: 'app-vertical-sidebar',
  standalone: true,
  imports: [TranslateModule, RouterModule, CommonModule, FeatherModule],
  templateUrl: './vertical-sidebar.component.html'
})
export class VerticalSidebarComponent implements OnInit {
  @Input() showClass: boolean = false;
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();
  showMenu = '';
  showSubMenu = '';
  // public sidebarnavItems: RouteInfo[] = [];
  public sidebarnavItems: any[] = [];

  constructor( private readonly localStorage: CryptoJsService
  ) {
    this.initializeMenu();
  }

  ngOnInit() { }


  async initializeMenu() {
    try {
      const storedMenu = this.localStorage.getItem("menu");
      const menuArray = storedMenu
        ? JSON.parse(storedMenu)
          .map(item => ({
            ...item,
            extralink: false,
            submenu: [],
            permission: true,
            labelClass: "",
            class: "",
            path: `/admin${item.path}`
          }))
          .sort((a, b) => a.name.localeCompare(b.name))
        : [];

      this.initializeArray(menuArray);

    } catch (error) {
      console.error('Error al inicializar el menú:', error);
    }
  }


  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  handleNotify() {
    this.notify.emit(!this.showClass);
  }

  /**
   * Initialize
   */
  initializeArray(routes): void {
    const pahtModulo = window.location.pathname.split('/')[1];
    //console.log('Routes', routes);
    ////console.log('pahtModulo',pahtModulo);
    this.sidebarnavItems = routes;
    // switch (pahtModulo) {
    //   case 'project':
    //     this.sidebarnavItems = routes;
    //     break;
    //   default:
    //     this.sidebarnavItems = routes.menu;
    //     break;
    // }
  }
}
